import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

const StyledWizardContainer = styled.div`
  width: 100%;
  height: 100%;
`;

/**
 * Primary UI component for user interaction
 */

const Wizard = ({ pages, startAtPage = 1 }) => {
  const [pageIndex, setPageIndex] = useState(startAtPage - 1);

  useEffect(() => {
    setPageIndex(startAtPage - 1);
  }, [startAtPage, setPageIndex]);

  const PageToRender = pages.find((page, index) => index === pageIndex).component;

  const back = () => pageIndex > 0 && setPageIndex(pageIndex - 1);

  const forward = () => pageIndex < pages.length - 1 && setPageIndex(pageIndex + 1);

  const goTo = (page) => {
    page >= 0 && page <= pages.length && setPageIndex(page - 1);
  };

  return (
    <StyledWizardContainer>
      <PageToRender
        pageIndex={pageIndex}
        currentPage={pageIndex + 1}
        goTo={goTo}
        back={back}
        forward={forward}
        totalPages={pages.length}
      />
    </StyledWizardContainer>
  );
};

Wizard.propTypes = {
  pages: PropTypes.array.isRequired,
};

Wizard.defaultProps = {
  pages: [{ component: (props) => <div /> }],
};

export { Wizard };
